import type {
  OrganizationInvitation,
  OrganizationMember,
  OrganizationRoleKey,
} from '@/components/org-settings/members/members.interface'

import type {
  ClerkInvitationResource,
  ClerkMembershipResource,
  ClerkPublicUserData,
} from './members-clerk.types'

const getUserId = (data?: ClerkPublicUserData | null): string => data?.userId ?? ''
const getEmail = (data?: ClerkPublicUserData | null): string => data?.identifier ?? ''
const getFirstName = (data?: ClerkPublicUserData | null): string | null => data?.firstName ?? null
const getLastName = (data?: ClerkPublicUserData | null): string | null => data?.lastName ?? null
const getImageUrl = (data?: ClerkPublicUserData | null): string | null => data?.imageUrl ?? null

export const transformMembership = (
  m: ClerkMembershipResource,
  currentUserId: string | null
): OrganizationMember => ({
  id: m.id,
  clerkUserId: getUserId(m.publicUserData),
  email: getEmail(m.publicUserData),
  firstName: getFirstName(m.publicUserData),
  lastName: getLastName(m.publicUserData),
  imageUrl: getImageUrl(m.publicUserData),
  memberRole: m.role as OrganizationRoleKey,
  createdAt: m.createdAt,
  isCurrentUser: m.publicUserData?.userId === currentUserId,
})

export const transformInvitation = (inv: ClerkInvitationResource): OrganizationInvitation => ({
  id: inv.id,
  emailAddress: inv.emailAddress,
  memberRole: inv.role as OrganizationRoleKey,
  status: inv.status as OrganizationInvitation['status'],
  createdAt: inv.createdAt,
})
